// @ts-nocheck
/* eslint-disable */

import * as Types from '../../graphql/v3/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FeedCityQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type FeedCityQuery = { __typename?: 'Query', city: { __typename?: 'City', id: number, name: string } };


export const FeedCityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeedCity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export function useFeedCityQuery(baseOptions: Apollo.QueryHookOptions<FeedCityQuery, FeedCityQueryVariables> & ({ variables: FeedCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedCityQuery, FeedCityQueryVariables>(FeedCityDocument, options);
      }
export function useFeedCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedCityQuery, FeedCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedCityQuery, FeedCityQueryVariables>(FeedCityDocument, options);
        }
export function useFeedCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedCityQuery, FeedCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedCityQuery, FeedCityQueryVariables>(FeedCityDocument, options);
        }
export type FeedCityQueryHookResult = ReturnType<typeof useFeedCityQuery>;
export type FeedCityLazyQueryHookResult = ReturnType<typeof useFeedCityLazyQuery>;
export type FeedCitySuspenseQueryHookResult = ReturnType<typeof useFeedCitySuspenseQuery>;